import React, { useMemo } from 'react';
import ICategorieClient from "../../models/ICategorieClient";
import GestionAbstract from '../../components/forms/gestion-abstract';
import Guid from '../../models/Guid';
import IBaseModel from '../../models/IBaseModel';

interface IGestionCategorieClientProps {
  isModeSelection?: boolean,
}

class CategorieClient extends IBaseModel implements ICategorieClient {
  idCategorieClient: Guid = Guid.empty;
}

export default function GestionCategorieClient({ isModeSelection }: IGestionCategorieClientProps) {
  return (<GestionAbstract<ICategorieClient> isModeSelection={isModeSelection} descriptionOptions={{ maxLength: 255 }} path="CategorieClient" model={CategorieClient} />);
}